import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormTextField, FormSwitch } from '../../../../lib/components';
import { FormChildAllowanceField } from '../../../../lib/components/compound/forms/form/fields/taxFields/childAllowanceField';
import { FormTaxClassSelect } from '../../../../lib/components/compound/forms/form/fields/taxFields/taxClassSelect';
import { ProfileForm, ProfileFormProps } from '../shared/profileForm';

type Props = Omit<ProfileFormProps, 'children'>;

export const TaxDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();

  const [currentChildCount, setCurrentChildCount] = useState(props.initialValues?.children_count);

  const [missingFields, setMissingFields] = useState<string[]>();

  useEffect(() => {
    setMissingFields(props.formRef?.current?.values?.missing_fields);
  }, [props.formRef?.current?.values?.missing_fields]);

  return (
    <ProfileForm {...props}>
      <FormTextField
        type="number"
        label={t('employee:NUMBER_OF_CHILDREN')}
        placeholder={t('employee:NUMBER_OF_CHILDREN')}
        name="children_count"
        inputProps={{
          min: 0,
          step: 1
        }}
        additionalOnChange={(v) => setCurrentChildCount(v as number | undefined)}
        xs={6}
      />
      <FormChildAllowanceField name="kinderfreibetrag" max={currentChildCount} xs={6} />
      <FormTaxClassSelect
        name="steuerklasse"
        options={[1, 2, 3, 4, 5, 6]}
        missing={missingFields?.includes('steuerklasse')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormSwitch label={t('employee:RELIGION')} name="religion" xs={6} />
    </ProfileForm>
  );
};
